<template>
	<v-dialog v-model="dialog" max-width="800px" persistent>
		<v-card class="rounded-xl elevation-8">
			<v-toolbar color="primary" dark flat>
				<v-icon left>mdi-folder-move-outline</v-icon>
				<span class="title font-weight-medium">Transferir tarea</span>
			</v-toolbar>

			<!-- Subtítulo -->
			<v-card-subtitle class="py-2 px-4">
				<v-icon small class="mr-1">mdi-clipboard-list-outline</v-icon>
				<span v-if="tasks.length === 1">
					Tarea: <strong>{{ tasks[0].TskTitle }}</strong>
				</span>
				<span v-else>
					Transferencia en bloque: <strong> {{ tasks.length }} tareas seleccionadas </strong>
				</span>
			</v-card-subtitle>

			<!-- Contenido -->
			<v-card-text class="pa-4">
				<v-row dense>
					<!-- Columna izquierda: lista de proyectos -->
					<v-col cols="6">
						<h4 class="subtitle-1 mb-2 font-weight-medium">Seleccionar proyecto destino:</h4>
						<v-list two-line dense class="scrollable white--bg rounded-lg elevation-1"
							style="max-height: 300px; overflow-y: auto;">
							<v-list-item-group v-model="selectedProjectIndex" color="primary">
								<v-list-item v-for="(project, index) in availableProjects" :key="project.TkpID"
									:disabled="project.TkpID === currentProjectId" class="hoverable">
									<v-list-item-avatar size="24">
										<v-icon small color="primary">mdi-laptop</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="text-truncate">{{ project.TkpTitle }}</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action v-if="project.TypeNivelUsr == 1">
										<v-chip small color="green lighten-2" text-color="white">
											{{ project.TypeNivelUsrName }}
										</v-chip>
									</v-list-item-action>
									<v-list-item-action v-else-if="project.TkpID === currentProjectId">
										<v-chip small outlined color="primary">Actual</v-chip>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-col>

					<!-- Columna derecha: motivo del traslado -->
					<v-col cols="6">
						<h4 class="subtitle-1 mb-2 font-weight-medium">Motivo del traslado:</h4>
						<v-textarea v-model="transferReason" placeholder="Escribe aquí el motivo" outlined auto-grow
							dense counter="100"></v-textarea>
					</v-col>
				</v-row>
			</v-card-text>

			<!-- Acciones -->
			<v-card-actions class="pa-3 grey lighten-4">
				<v-spacer></v-spacer>
				<v-btn text color="grey darken-1" @click="cancelTransfer" class="font-weight-medium">
					Cancelar
				</v-btn>
				<v-btn color="primary" class="elevation-2 font-weight-medium" @click="confirmTransfer"
					:disabled="selectedProjectIndex == null" :loading="transferring">
					<v-icon left>mdi-folder-move</v-icon>
					Transferir
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';

export default {
    name: 'TaskProjectTransferModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        tasks: {
            type: Array,
            default: () => []
        },
        projects: {
            type: Array,
            default: () => []
        },
        currentProjectId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            selectedProjectIndex: null,
            transferReason: "",
            transferring: false,
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        availableProjects() {
            return this.projects.filter(project => {
				return project.TkpStatus !== 3; // No incluir proyectos cerrados
			});
        },
        selectedProject() {
			if (this.selectedProjectIndex !== null && this.selectedProjectIndex !== undefined) {
				return this.availableProjects[this.selectedProjectIndex];
			}
			return null;
		}
    },
    watch: {
        dialog(val) {
            if (val) {
                this.selectedProjectIndex = null;
                this.transferReason = "";
            }
        }
    },
    methods: {
        cancelTransfer() {
            this.dialog = false;
        },
        async confirmTransfer() {
			if (!this.selectedProject) {
				return;
			}

			const count = this.tasks.length;
			this.$fun.alert(`¿Seguro de transferir ${count > 1 ? count + ' tareas' : 'esta tarea'} a ${this.selectedProject.TkpTitle}?`, "question")
				.then(async r => {
					if (r.value) {
						this.transferring = true;
						try {
							for (const task of this.tasks) {
								const transferData = {
									TskID: task.TskID,
									TkpID: this.selectedProject.TkpID,
									TskReasonTraslate: this.transferReason,
									PrsIDTraslate: this.$fun.getUserInfo().PrsID,
									UsrUpdateID: this.$fun.getUserID()
								};
								await _sTaskService.transfer(transferData, this.$fun.getUserID());
							}

							this.$fun.alert(`${count > 1 ? count + ' tareas transferidas' : 'Tarea transferida'} correctamente al proyecto ${this.selectedProject.TkpTitle}`, 'success');
							this.$emit('transferred');
							this.dialog = false;
						} catch (error) {
							console.error("Error en transferencia:", error);
							this.$fun.alert("Error al transferir algunas tareas", "error");
						} finally {
							this.transferring = false;
						}
					}
				});
		}
    }
};
</script>
<style scoped>
.rounded-xl {
	border-radius: 16px !important;
}
.scrollable {
	max-height: 450px;
	overflow-y: auto;
}
.hoverable:hover {
	background-color: rgba(0, 0, 0, 0.03);
	cursor: pointer;
}
.white--bg {
	background-color: white;
}
.elevation-1 {
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: 70%;
}
</style>
